import { render, staticRenderFns } from "./FragmentIframe.vue?vue&type=template&id=46516c5b"
import script from "./FragmentIframe.vue?vue&type=script&lang=ts"
export * from "./FragmentIframe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports